const currentDate = new Date();
const currentHours = currentDate.getHours();
const currentMinutes = currentDate.getMinutes();
const currentSeconds = currentDate.getSeconds();
const currentTimeInSeconds = () =>
  currentSeconds + 60 * currentMinutes + 60 * 60 * currentHours;

const getOpeningTimes = (dayShifts) => {
  const openingTimes = [];
  dayShifts.forEach((shift) => {
    const shiftHours = Number(shift.start.substring(0, 2));
    const shiftMinutes = Number(shift.start.substring(3, 5));
    const shiftSeconds = Number(shift.start.substring(6, 8));
    const secondsInTheDay =
      shiftSeconds + 60 * shiftMinutes + 60 * 60 * shiftHours;
    openingTimes.push({
      time: shift.start,
      timeInSeconds: secondsInTheDay,
    });
  });
  return openingTimes;
};

const getClosingTimes = (dayShifts) => {
  const closingTimes = [];
  dayShifts.forEach((shift) => {
    const shiftHours = Number(shift.end.substring(0, 2));
    const shiftMinutes = Number(shift.end.substring(3, 5));
    const shiftSeconds = Number(shift.end.substring(6, 8));
    const secondsInTheDay =
      shiftSeconds + 60 * shiftMinutes + 60 * 60 * shiftHours;
    closingTimes.push({
      time: shift.end,
      timeInSeconds: secondsInTheDay,
    });
  });
  closingTimes.sort(
    (first, second) => first.timeInSeconds - second.timeInSeconds,
  );
  return closingTimes;
};

// Sets the scheduled opening time as the opening time closest to the current time
export const getScheduledOpeningTime = (currentDayShifts, nextDayShifts) => {
  const scheduledOpenTimes = [];
  getOpeningTimes(currentDayShifts).forEach((openTime) => {
    if (currentTimeInSeconds() < openTime.timeInSeconds) {
      scheduledOpenTimes.push(openTime.time);
    }
  });
  if (scheduledOpenTimes.length) return scheduledOpenTimes[0];
  return getOpeningTimes(nextDayShifts)[0].time;
};

// Sets the scheduled closing time as the closing time closest to the current time
export const getScheduledClosingTime = (currentDayShifts) => {
  const scheduledClosingTimes = [];
  getClosingTimes(currentDayShifts).forEach((closingTime) => {
    if (currentTimeInSeconds() < closingTime.timeInSeconds) {
      scheduledClosingTimes.push(closingTime.time);
    }
  });
  return scheduledClosingTimes[0];
};
